/**
 * IncomeUpdated.contract.ts — Event Contract System™ (generation v1).
 * DOMAIN INTEGRATION HARDENING sprint: an existing income ledger entry changed
 * (currently: deletion) through the Career Domain Service.
 */

import type { EventContract } from '../EventContractRegistry';

export const IncomeUpdatedContract: EventContract = {
  name: 'IncomeUpdated',
  version: 1,
  description: 'An existing income entry changed (deleted/updated) via Career™.',
  publishers: ['career-domain'],
  subscribers: ['income-page', 'companies-page', 'module:wallet'],
  fields: [
    { name: 'entryId', type: 'number', required: true, description: 'API income entry id affected' },
    { name: 'changeKind', type: 'string', required: true, description: "'deleted' | 'updated'" },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) after the API mutation succeeds.',
  stability: 'stable',
  deprecated: false,
  example: { entryId: 42, changeKind: 'deleted' },
};
